export const EXCMCORRESPONDENCE_SHOW_RESET = 'EXCMCORRESPONDENCE_SHOW_RESET'
export const EXCMCORRESPONDENCE_SHOW_SET_ERROR = 'EXCMCORRESPONDENCE_SHOW_SET_ERROR'
export const EXCMCORRESPONDENCE_SHOW_SET_RETRIEVED = 'EXCMCORRESPONDENCE_SHOW_SET_RETRIEVED'
export const EXCMCORRESPONDENCE_SHOW_TOGGLE_LOADING = 'EXCMCORRESPONDENCE_SHOW_TOGGLE_LOADING'
